module.exports = "\r\n<layout-header></layout-header>\r\n<div style=\"margin-bottom:80px;\">\r\n<router-outlet></router-outlet>\r\n</div>\r\n\r\n<layout-footer></layout-footer>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = 788
// module chunks = 1